import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'

/** Border color for ColorSelector `variant="outlined" color="inherit"` swatch button. */
export const getColorSelectorOutlinedBorderColor = (theme: Theme) =>
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'

/** Hover border on the same control (MUI outlined inherit button hover). */
export const getColorSelectorOutlinedBorderHoverColor = (theme: Theme) =>
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'rgba(0, 0, 0, 0.87)'

/** Active ring when ColorSelector popover / equivalent is open. */
export const getColorSelectorActiveOutlineSx = (theme: Theme): SystemStyleObject<Theme> => ({
    outline: '2px solid',
    outlineColor: theme.palette.primary.main,
    outlineOffset: '1px',
})

/** Outlined TextField / Select chrome aligned with ColorSelector swatch button. */
export const getColorSelectorMatchedFieldOutlineSx = (theme: Theme): SystemStyleObject<Theme> => {
    const borderColor = getColorSelectorOutlinedBorderColor(theme)
    const hoverBorderColor = getColorSelectorOutlinedBorderHoverColor(theme)

    return {
        '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${borderColor} !important`,
            borderWidth: '1px !important',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: `${borderColor} !important`,
            borderWidth: '1px !important',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: `${borderColor} !important`,
            borderWidth: '1px !important',
        },
        '& .MuiOutlinedInput-root.Mui-focused': {
            boxShadow: 'none',
        },
        '&.Mui-focused': {
            boxShadow: 'none',
        },
        // After focus rules so hover still applies once the field keeps focus (e.g. after closing the menu).
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${hoverBorderColor} !important`,
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${hoverBorderColor} !important`,
        },
        '&.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${hoverBorderColor} !important`,
        },
        '& .MuiOutlinedInput-root.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${hoverBorderColor} !important`,
        },
    }
}
